<div class="w-100">
  <mwp-card-content-header [url]="apiUrl" />
  <div class="mt-3">
    <div class="content-container mb-3">
      <div class="title">
        <mwp-text-translate text="Select Carrier" jsonKey="selectCarrier" />
      </div>
      <div class="content">
        <form [formGroup]="agentControlForm">
          <div class="d-flex flex-wrap row">
            <div class="col-3 pb-3">
              <mwp-dropdown [form]="agentControlForm" nameForControl="brokerId" [data]="brokers" keyText="name" keyValue="id" (emitSelected)="brokerChange($event)" labelName="Select Broker" />
            </div>
            @if (carriers) {
              <div class="col-3 pb-3">
                @if (carriers.length == 0) {
                  <mwp-text-translate text="No Carries For Broker" jsonKey="carrierInfoNoCarriesForBroker" />
                }
                @if (carriers.length > 0) {
                  <mwp-dropdown [form]="agentControlForm" nameForControl="carrierID" [data]="carriers" keyText="name" keyValue="id" (emitSelected)="carrierChange($event)" labelName="Select Carrier" />
                }
              </div>
            }
            @if (companies) {
              <div class="col-3 pb-3">
                @if (companies.length == 0) {
                  <mwp-text-translate text="No Companies For Carrier" jsonKey="carrierInfoNoCompaniesForCarrier" />
                }
                @if (companies.length > 0) {
                  <mwp-dropdown [form]="agentControlForm" nameForControl="companyID" [data]="companies" keyText="companyName" keyValue="companyID" (emitSelected)="companyChange($event)" labelName="Filters" />
                }
              </div>
              <div class="col-3 pb-3">
                <mat-checkbox [checked]="includeDisabled" class="fw-bold" (change)="includeDisableChange($event)">
                  <mwp-text-translate text="Include Disabled" jsonKey="includeDisabled" />
                </mat-checkbox>
              </div>
            }
          </div>
        </form>
        @if (agentCarrierInfoForm && showAgentCarrierResults) {
        <div>
          <div class="mb-3">
            <mwp-table-formarray [form]="agentCarrierInfoForm" [arrayName]="agentCarrierInfoFormArrayName" [tableColumns]="agentCarrierColumns" [dataSource]="agentCarrierMatTableData" [hasControls]="true" />
          </div>
        </div>
        }
        <div class="d-inline-flex justify-content-end w-100 p-3">
          <button class="mwp-button-save" [disabled]="!agentCarrierInfoForm || !agentCarrierInfoForm.valid" (click)="save()">
            <mwp-text-translate text="Save" jsonKey="save" />
          </button>
        </div>
      </div>
    </div>
  </div>
</div>